import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetMediaPhotoGalleryResponse,
  PostMediaPhotoGalleryResponse,
  GetMediaPhotoGalleryByIdResponse,
  PutMediaPhotoGalleryResponse,
} from '../response/photo-gallery';

export class PhotoGalleryService {
  static getPhotoGalleries(params?: QueryParams) {
    return apiClient.get<GetMediaPhotoGalleryResponse>(buildApiUrl('/api/v1/media/photo-gallery'), params);
  }

  static postPhotoGallery(data: any) {
    return apiClient.createWithFile<PostMediaPhotoGalleryResponse>(buildApiUrl('/api/v1/media/photo-gallery'), data);
  }

  static getPhotoGalleryById(id: string) {
    const url = buildApiUrl('/api/v1/media/photo-gallery/:id', { id });
    return apiClient.get<GetMediaPhotoGalleryByIdResponse>(url, undefined);
  }

  static putPhotoGallery(id: string, data: any) {
    return apiClient.updateWithFile<PutMediaPhotoGalleryResponse>(buildApiUrl('/api/v1/media/photo-gallery/:id', { id }), data);
  }

  static deletePhotoGallery(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/media/photo-gallery/:id', { id }), undefined);
  }
}
